module.exports = __webpack_public_path__ + "img/project-20.652392e2.png";